import { useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { Sidebar, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { APP_CITY } from "../../../../common/constants/appCity"
import { MODULE_VERTICAL_SIGNING } from "../../../../common/constants/modules"
import { VerticalSigningSidebar } from "../../containers/VerticalSigningSidebar"
import { VerticalSignPoleDetailsSidebar } from "../../containers/VerticalSignPoleDetailsSidebar/VerticalSignPoleDetailsSidebar"
import { useVerticalSigningStateContext } from "../../contexts/VerticalSigningContext"

import { VerticalSignPoleValidator } from "../VerticalSignPoleValidator"

export function VerticalSigningSidebarRouter() {
    const { ascendantCodes, descendantCodes } = useVerticalSigningStateContext()
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        { path: "/", element: <VerticalSigningSidebar /> },
        { path: "/:road", element: <VerticalSigningSidebar /> },
        { path: "/:road/:signId", element: <VerticalSignPoleValidator><VerticalSignPoleDetailsSidebar /></VerticalSignPoleValidator> },
    ]), [])

    const matchDetail = useMatch(`:slugId/${APP_CITY}/${MODULE_VERTICAL_SIGNING}/:road/:signId`)

    const sidebarCount = useMemo(() => {
        const hasAdditionalSidebar = ascendantCodes.length % 2 === 1 || descendantCodes.length > 1
        return matchDetail ? 1 : Math.floor(ascendantCodes.length / 2) + (hasAdditionalSidebar ? 1 : 0)
    }, [ascendantCodes, descendantCodes, matchDetail])

    return <Sidebar shadowed={!isMobile && sidebarCount >= 2}>{useRoutes(sidebarRoutes)}</Sidebar>
}
